<div
  mat-dialog-content
  class="dialog-content text-dark font-size-primary"
  style="padding: 0 !important; color: initial"
>
  <ng-content></ng-content>
</div>
